var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 10.0003H8.66634V6.00033H10.6663L7.99967 2.66699L5.33301 6.00033H7.33301V10.0003Z",
    fill: "#CF0A2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 11.9997H2.66634V7.33301H1.33301V11.9997C1.33301 12.735 1.93101 13.333 2.66634 13.333H13.333C14.0683 13.333 14.6663 12.735 14.6663 11.9997V7.33301H13.333V11.9997Z",
    fill: "#CF0A2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadRed);
export default __webpack_public_path__ + "static/media/uploadRed.a834c961744c21254f68c3f12be86e99.svg";
export { ForwardRef as ReactComponent };